const defaultState = {
  isReconnecting: false,
  isConnected: true
};

export default defaultState;
